import { Link, useParams } from "react-router-dom";
import { featured } from "../data/projects";
import { ProjectVisual } from "../components/projects/ProjectVisual";
export function CaseStudy() {
  const { slug } = useParams();
  const index = featured.findIndex((p) => p.slug === slug);
  const p = featured[index];
  if (!p)
    return (
      <main id="main-content" className="shell not-found" tabIndex={-1}>
        <span className="eyebrow">404 / PROJECT NOT FOUND</span>
        <h1>
          This page took
          <br />a different route.
        </h1>
        <Link className="button button-primary" to="/">
          Back to the portfolio ↗
        </Link>
      </main>
    );
  const next = featured[(index + 1) % featured.length];
  return (
    <main id="main-content" className="case-study" tabIndex={-1}>
      <div className="shell">
        <Link className="back-link" to="/#work">
          ← Back to selected work
        </Link>
        <div className="case-heading">
          <span className="eyebrow">{p.category}</span>
          <h1>
            {p.name}
            <span className="accent">.</span>
          </h1>
          <p>{p.summary}</p>
        </div>
        <div className="case-meta">
          <div>
            <span>MY ROLE</span>
            <p>{p.role}</p>
          </div>
          <div>
            <span>TECHNOLOGIES</span>
            <p>{p.tags.join(" · ")}</p>
          </div>
          <div className="case-links">
            {p.live && (
              <a
                className="text-link"
                href={p.live}
                target="_blank"
                rel="noreferrer"
              >
                Visit website ↗
              </a>
            )}
            {p.github && (
              <a
                className="text-link"
                href={p.github}
                target="_blank"
                rel="noreferrer"
              >
                View source ↗
              </a>
            )}
          </div>
        </div>
        <ProjectVisual project={p} eager />
        <p className="image-credit">{p.credit}</p>
        <div className="case-body">
          <span className="eyebrow">01 / THE CONTEXT</span>
          <div data-reveal>
            <h2>
              The product
              <br />
              <em>and the purpose.</em>
            </h2>
            <p className="large-copy">{p.context}</p>
          </div>
          <span className="eyebrow">02 / MY CONTRIBUTION</span>
          <div data-reveal>
            <h2>What I worked on.</h2>
            <ul className="responsibilities">
              {p.responsibilities.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <span className="eyebrow">03 / ENGINEERING NOTES</span>
          <div data-reveal>
            <h2>Behind the interface.</h2>
            {p.decisions.map((item) => (
              <div className="decision" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
          <span className="eyebrow">04 / THE RESULT</span>
          <div data-reveal>
            <h2>What the work delivered.</h2>
            <p className="large-copy">{p.outcome}</p>
          </div>
        </div>
        <Link className="next-project" to={`/work/${next.slug}`}>
          <span className="eyebrow">NEXT PROJECT</span>
          <strong>{next.name}</strong>
          <span aria-hidden="true">↗</span>
        </Link>
      </div>
    </main>
  );
}
